const SOURCE_SYSTEM = 'SYSTEM'

/**
 * Determine whether a given product should be considered active. System products are also considered inactive.
 *
 * @method isProductActive
 *
 * @param  {Object} product
 *         The product to inspect
 *
 * @return {Boolean} true if the product is not a system product and is set to active, false otherwise
 */
export function isProductActive(product: any) {
  const isActive = Boolean(product.active)
  // Although deleted products arent synced, they are temporarily stored whilst handling sales that contain
  // them. Ensure these don't appear in results.
  const isDeleted = Boolean(product.deleted_at)

  // System products should not be sold so we consider them inactive
  const isSystemProduct = product.source === SOURCE_SYSTEM

  return isActive && !isDeleted && !isSystemProduct
}

/**
 * Determine whether a given product is a variant of another product.
 *
 * @method isProductVariant
 *
 * @param  {Object} product
 *         The product to inspect
 *
 * @return {Boolean} true if the given product is a variant of another product, false otherwise
 */
export function isProductVariant(product: any) {
  return Boolean(product.variant_parent_id)
}

/**
 * Determine whether the given product should be updated in the search index (or removed from). A product should be
 * updated if it is both active and not a variant.
 *
 * @method shouldUpdateProductInSearchIndex
 *
 * @param  {Object} product
 *         The product to inspect
 *
 * @return {Boolean} true if the product should be updated in the search index, false if it should be removed
 */
export function shouldUpdateProductInSearchIndex(product: any) {
  return isProductActive(product) && !isProductVariant(product)
}
